import { render, staticRenderFns } from "./passengerPort.vue?vue&type=template&id=6b5ce70a&scoped=true"
import script from "./passengerPort.vue?vue&type=script&lang=js"
export * from "./passengerPort.vue?vue&type=script&lang=js"
import style0 from "./passengerPort.vue?vue&type=style&index=0&id=6b5ce70a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ce70a",
  null
  
)

export default component.exports